import { Button } from "@/components/button"
import { SelectInput } from "@/components/inputs/select-input"
import { TextInput } from "@/components/inputs/text-input"
import MenuPageLayout from "@/components/layouts/MenuPageLayout"
import { queryClient } from "@/hooks/resources"
import { request } from "@/utils/request"
import { useIonRouter } from "@ionic/react"
import { FieldValues, useForm } from "react-hook-form"

const AddChildPage = () => {
  const router = useIonRouter()
  const { handleSubmit, control, setError, formState: { isLoading } } = useForm<FieldValues>({
    defaultValues: {
      firstName: "",
      lastName: "",
      gender: "",
      ageRange: ""
    }
  })

  const onSubmit = async (data: FieldValues) => {
    console.log(data)
    const response = await request.post("/children", data)

    if (response.ok) {
      queryClient.invalidateQueries({ queryKey: ["/child_authorizations"] })

      router.push("/account")
    }
    else {
      if (response.errors) {
        for (const [field, errors] of Object.entries<Array<string>>(
          response.errors,
        )) {
          setError(field, { type: "manual", message: errors.join(", ") + "." });
        }
      }
    }
  }

  return <MenuPageLayout title="Add Child">
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4 w-full max-w-screen-md">
      <div className="flex gap-4 w-full">
        <TextInput control={control} name="firstName" label="First Name" />
        <TextInput control={control} name="lastName" label="Last Name" />
      </div>

      <div className="flex gap-4 w-full">
        <SelectInput control={control} name="gender" label="Gender">
          <option value="">Please select</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
        </SelectInput>

        <SelectInput control={control} name="ageRange" label="Age Range">
          <option value="">Please select</option>
          <option value="under_two">Under 2</option>
          <option value="two_to_three">2 to 3</option>
          <option value="four_to_five">4 to 5</option>
          <option value="six_or_older">Over 5</option>
        </SelectInput>
      </div>

      <Button type="submit" className="btn-secondary px-12 mx-auto" loading={isLoading}>
        Save Child
      </Button>
    </form>
  </MenuPageLayout>
}

export default AddChildPage
